export const COLORS = {
    primary: '#000',
    accent: '#000',
    secondary: '#000',
    primaryText: '#000',
    placeholderText: '#000',
    accentText: '#000',
    secondaryText: '#000',
    red: '#d13435',
    blue: '#1B4EF7',
    gray: '#575C69',
    darkGray: '#9198AA',
    lightGreen: '#000',
    lightGray: '#ECEFF6',
    white: '#fff',
    dark: '#333',
    black: '#000',
    special: 'red',
    blockShadow: '#000',
};

export const BACKGROUNDS = {
    primary: '#1C3E60',
    primaryFlat: 'blue',
    accent: 'blue',
    accentAlt: 'blue',
    secondary: 'blue',
    red: 'blue',
    blue: 'blue',
    gray: '575C69',
    darkGray: '#9198AA',
    lightGray: '#ECEFF6',
    white: '#fff',
    black: 'blue',
    darkgreen: 'blue',
    none: 'blue',
    hugeBlockGradient: 'blue',
    navigation: 'blue',
    navigationActiveElement: 'blue',
};

export const themes = {
    default: {
        text: {
            white: '#fff',
            black: '#000',
            neutralBlack: '#1E1E1E',
            neutralDarkSemiGrey: '#8C94A0',
            neutralLightSemiGrey: '#BFC9D9',
            liveRedDark: '#CC0808',
            toolbarArrowDark: '#2C3036',
            toolbarNeutralDark: '#333333',
            infoIconDefault: '#186BF5',
        },
        bg: {
            secondaryWhite: '#FFF',
            neutralGrey: '#F5F8FC',
            sportPrimary: '#1C3F61',
            semanticErrorBackgroundLight: '#FEEAEA',
            ctaPrimary: '#fdd804',
        },
        borders: {
            neutralBorder: '#DFE5ED',
            secondaryOutline: '#DFE3ED',
            primaryBorder: '#E4E9EF',
            accentBorder: '#FDD804',
        },
    },
    dark: {},
};
